// 9fbef606107a605d69c0edbcd8029e5d
import { getDynamicLabelValues } from '@tcp/core/src/utils/labels/labelUtilty';

export const GLOBAL_GETCANDID_LABELS = 'global.getCandid';

// TODO: Label - GetCandid Dynamic
export const dynamicGetCandidTitleLabel = getDynamicLabelValues('dynamic.home.lbl_getCandid_title');

export const globalGetCandidLabelsCopy = {
  global: {
    getCandid: {
      lbl_getCandid_BtnGallery: 'VIEW GALLERY',
      lbl_getCandid_BtnLoadMore: 'LOAD MORE',
      lbl_getCandid_BtnPhoto: 'ADD PHOTO',
      lbl_getCandid_BtnShopNow: 'SHOP NOW',
      lbl_getCandid_btnSeeMore: 'See More',
      lbl_getCandid_titleDescription: `Show us how you're celebrating every big & small occasion, in style!`,
    },
  },
};
